



















import { Component, Prop, Vue, Model, Watch } from 'vue-property-decorator';
import PaneSet, { Pane, PaneStatus } from './PaneSet';
import { OnResizeDirective } from './OnResize';
import { TouchEvent } from './TouchEvent';

@Component({
  name: 'msplit',
  directives: {
    'on-resize': OnResizeDirective.instance,
  },
})
export default class MSplit extends Vue {
  @Prop({default: false}) private vertical!: boolean;
  @Prop({default: ''}) private maxPane!: string;
  private count = 0;
  private startPos = -1;
  private startHandlePos = -1;
  private paneSet = new PaneSet();
  private vnodes = new Array<Vue.VNode>();
  private resizeIndex = -1;
  private show: boolean[][] = [];

  private getPos(e: MouseEvent | TouchEvent): number {
    const pos = (e instanceof MouseEvent) ? e : e.touches.item(0);
    return this.vertical ? pos.clientY : pos.clientX;
  }

  private startResize(i: number, e: MouseEvent | TouchEvent): void {
    if (this.paneSet.maxPane)
      return;
    this.resizeIndex = i;
    this.startPos = this.getPos(e);
    this.startHandlePos = this.paneSet.getHandlePos(i);
  }

  private resizing(e: MouseEvent | TouchEvent): void {
    if (this.resizeIndex < 0)
      return;
    const newPos = this.getPos(e);
    this.paneSet.moveHandle(this.resizeIndex, this.startHandlePos + newPos - this.startPos);
    e.stopPropagation();
  }

  private stopResize(): void {
    this.resizeIndex = -1;
  }

  private onWindowResize() {
    if (!this.$el)
      return;
    this.$emit('resize');
    this.paneSet.totalSize = this.vertical ? this.$el.clientHeight : this.$el.clientWidth;
    this.paneSet.calculateSize();
  }

  get paneStyle() {
    return (i: number) => ({
      [this.vertical ? 'height' : 'width']: `${this.paneSet.panes[i].getDisplaySize()}px`,
    });
  }

  get handleStyle() {
    return (i: number) => ({
      [this.vertical ? 'top' : 'left']: `${this.paneSet.getHandlePos(i)}px`,
      [this.vertical ? 'height' : 'width']: '5px',
      cursor: this.vertical ? 'row-resize' : 'col-resize',
    });
  }

  get visible() {
    return (i: number) => this.paneSet.panes[i].visible();
  }

  @Watch('maxPane')
  maxPaneUpdated() {
    this.paneSet.setMaxPane(this.maxPane);
    this.paneSet.calculateSize();
  }

  @Watch('show', {immediate: true, deep: true})
  showUpdated() {
    if (this.show.length < this.paneSet.panes.length)
      return;
    for (let i = 0; i < this.paneSet.panes.length; i++)
      this.paneSet.panes[i].setStatus(this.show[i][0] ? PaneStatus.NORMAL : PaneStatus.MIINIMIZED);
    this.paneSet.calculateSize();
  }

  mounted() {
    let i = 0;
    for (const skey in this.$slots) {
      if (!this.$slots.hasOwnProperty(skey))
        continue;
      const vnode = this.$slots[skey]![0];
      if (vnode) {
        const { attrs, slot } = vnode!.data!;
        if (attrs) {
          let show = attrs.show;
          if (show === undefined)
            show = [true];
          else if (!Array.isArray(show))
            throw new Error(`show attribute for pane has to be array: show=${attrs.show}, paneName=${skey}`);

          this.$set(this.show, i++, show);
          this.paneSet.addPane(new Pane(slot!, parseInt(attrs.size), parseInt(attrs.min), parseInt(attrs.max), parseInt(attrs.grow)));
        }
      }
    }
    this.maxPaneUpdated();
    this.paneSet.totalSize = this.vertical ? this.$el.clientHeight : this.$el.clientWidth;
    this.paneSet.calculateSize();
  }
}
